import { createRevenue } from 'api/v1/revenues';
import { getRevenues } from 'api/v2/revenues';
import { uploadFile } from 'api/v2/upload';
import { dateToPeriod } from 'components/molecules/Fields/Period/utils';
import dayjs from 'dayjs';
import tabStateCreator from 'store/shared/tabState';
import { RevenuesCacheKeys } from 'types/cacheKeys.types';
import { Period, VATReturnFrequency } from 'types/global.types';
import {
  WhyZeroVATEnum,
  type InvoiceItem,
  type InvoiceStatus,
  type InvoiceType,
} from 'types/invoice.types';
import { UploadTypesEnum } from 'types/uploadEnums.types';
import { VATType } from 'types/users.types';

export const createRevenueDocument = (
  file: File,
  revenueType: InvoiceType,
  onProgress: (n: number) => void,
) => {
  return uploadFile({
    file,
    onProgress,
    category: UploadTypesEnum.invoice,
  }).then(({ key }: any) => createRevenue(key.split('/').pop(), revenueType));
};

export const hasRevenues = () =>
  getRevenues({ page: 1, perPage: 1 }).then(
    ({ paging }) => paging.totalCount > 0,
  );

export const firstRevenue = () =>
  getRevenues({ page: 1, perPage: 1, sort: 'created_asc' });

type Options = {
  invoiceDate: string;
  invoicePeriod?: Period;
  VATType: VATType;
  VATFreq: VATReturnFrequency;
  currentStatus: InvoiceStatus;
};

export const getBelgianQuickActionsVATPeriod = (options: Options) => {
  if (options.VATType !== 'subjectToVAT') return undefined;
  if (options.currentStatus === 'not-sent') {
    return dateToPeriod(dayjs(options.invoiceDate), options.VATFreq);
  }
  return options.invoicePeriod;
};

export const isIntraEUReverseCharge = (items?: Partial<InvoiceItem>[]) => {
  return !!items?.some(
    (item) => item.whyZeroVAT === WhyZeroVATEnum.intra_eu_reverse_charge,
  );
};

export const useRevenuessActiveTabState = tabStateCreator<string>(
  RevenuesCacheKeys.PrimaryRevenueTab,
);
